/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable import/extensions */
import React, { useState, useEffect, useRef } from 'react';
import * as Sentry from '@sentry/react';
import firebase from 'firebase/app';
import { Link } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { FaFacebookSquare } from 'react-icons/fa';

import PATH from 'routes/path';

import fb from 'firebaseConfig';

import Loading from 'components/Loading';
import Menu from 'components/Menu';
import { Button } from 'components/Button';
import { Title, Text } from 'components/Text';
import { ALERT_TYPE } from 'components/Alert';
import { SimpleInputMask } from 'components/InputMask';
import { Input } from 'components/Input';
import SnackMessage, { OPTIONS } from 'components/SnackMessage';

import { firebaseErrors } from 'services/api/firebaseErrors';

import GoogleIcon from 'assets/icons/SvgIcons/Google.js';

import CodeModal from '../SignUp/CodeModal';
import EmailModal from '../SignUp/EmailModal';
import MissingCodeModal from '../SignUp/MissingCodeModal';

import {
  Wrapper,
  Divider,
  Container,
} from '../SignUp/styles';

const Login = () => {
  const [user, setUser] = useState({
    phone: '',
    email: '',
  });
  const [signMethod, setSignMethod] = useState(localStorage.getItem('webview') ? 'phone' : 'email');
  const [complete, setComplete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openMissingModal, setMissingModal] = useState(false);
  const [openEmailModal, setEmailModal] = useState(false);
  const mktInputRef = useRef(null);

  const { enqueueSnackbar } = useSnackbar();

  // Provedor de Autenticação (Google)
  const googleProvider = new firebase.auth.GoogleAuthProvider();

  // Provedor de Autenticação (Facebook)
  const facebookProvider = new firebase.auth.FacebookAuthProvider();

  // Config. para login por link de email
  const actionCodeSettings = {
    handleCodeInApp: true,
    url: `${process.env.REACT_APP_APP_URL}/login`,
    // android: {
    //   packageName: 'com.loitfgts',
    // },
    // dynamicLinkDomain: 'loitfgts.page.link',
  };

  // Verifica se é um link de redirecionamento para login (link via Email)
  const verifyLoginWithEmailLink = async () => {
    // Confirm the link is a sign-in with email link.
    if (fb.auth().isSignInWithEmailLink(window.location.href)) {
      setLoadingPage(true);

      const email = window.localStorage.getItem('emailForSignIn');
      const name = window.localStorage.getItem('nameForSignIn');

      if (!email) {
        enqueueSnackbar('Desculpe, esse link de acesso está expirado.', {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        });
      }

      try {
        await fb.auth().signInWithEmailLink(email, window.location.href);

        if (name) {
          await fb.auth().currentUser.updateProfile({
            displayName: name,
          });

          localStorage.events = JSON.stringify([
            '12 - cadastro email',
            '22 - acesso email',
          ]);

          window.localStorage.removeItem('nameForSignIn');
        } else {
          localStorage.events = JSON.stringify([
            '22 - acesso email',
          ]);
        }

        localStorage.session = 'true';
        window.localStorage.removeItem('emailForSignIn');
      } catch (error) {
        if (error.code) {
          enqueueSnackbar(firebaseErrors[error.code], {
            ...OPTIONS,
            content: (key, message) => (
              <SnackMessage
                id={key}
                message={message}
                variant={ALERT_TYPE.ERROR}
              />
            ),
          });
        }
      } finally {
        setLoadingPage(false);
      }
    }
  };

  useEffect(() => {
    document.title = 'LOIT FGTS - Revisão monetária do seu FGTS';

    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', { size: 'invisible' });
    verifyLoginWithEmailLink();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setUser({
      ...user,
      [name]: value,
    });
  };

  // Reseta container do reCAPTCHA
  const resetRecaptcha = () => window.recaptchaVerifier.reset();

  const showModal = () => {
    if (openMissingModal) setMissingModal(false);
    setOpenModal(true);
  };

  const closeModal = () => {
    setLoading(false);
    setOpenModal(false);
    resetRecaptcha();
  };

  const showMissingModal = () => {
    if (openModal) setOpenModal(false);
    setMissingModal(true);
  };

  const closeMissingModal = () => {
    setLoading(false);
    setMissingModal(false);
    resetRecaptcha();
  };

  const showEmailModal = () => {
    setOpenModal(false);
    setEmailModal(true);
  };

  const closeEmailModal = () => {
    setLoading(false);
    setEmailModal(false);
  };

  // Login com a conta do Google
  const handleSignWithGoogle = async () => {
    try {
      await fb.auth().signInWithPopup(googleProvider);
      /** @type {firebase.auth.OAuthCredential} */
      // const credential = result.credential;
      // const token = credential.accessToken;

      localStorage.session = 'true';

      localStorage.events = JSON.stringify([
        '21 - acesso google',
        '50 - primeiro acesso',
      ]);

      // const user = result.user;
      localStorage.setItem('mkt_cookies', mktInputRef.current.value);
      localStorage.setItem('event', 'register/customer');
    } catch (error) {
      Sentry.captureException(new Error('failed to login with email'));
      if (error.code) {
        enqueueSnackbar(firebaseErrors[error.code], {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        });
      }
    }
  };

  // Login por link por email
  const handleSignWithEmail = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      await fb.auth().sendSignInLinkToEmail(user.email, actionCodeSettings);

      setComplete(true);
      showEmailModal();

      localStorage.events = JSON.stringify([
        '31 - envio email',
      ]);

      localStorage.setItem('emailForSignIn', user.email);
      localStorage.setItem('mkt_cookies', mktInputRef.current.value);
      localStorage.setItem('event', 'register/customer');
    } catch (error) {
      Sentry.captureException(new Error('failed to login with email link'));
      if (error.code) {
        enqueueSnackbar(firebaseErrors[error.code], {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        });
      }
    } finally {
      setLoading(false);
    }
  };

  // Exibe recaptcha e envia o código de verificação
  const handleSignInWithPhone = async (e) => {
    e.preventDefault();

    setLoading(true);

    const appVerifier = window.recaptchaVerifier;

    try {
      const result = await fb.auth().signInWithPhoneNumber(user.phone, appVerifier);
      window.confirmationResult = result;

      // Exibe modal para inserir o código de verificação
      showModal();
      localStorage.setItem('mkt_cookies', mktInputRef.current.value);
      localStorage.setItem('event', 'register/customer');
    } catch (error) {
      setLoading(false);
      Sentry.captureException(new Error('failed to login with phone'));
      if (error.code) {
        enqueueSnackbar(firebaseErrors[error.code], {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        });
      }
      resetRecaptcha();
    }
  };

  // Completa login após confirmação do código de verificação
  const completeVerification = async (code) => {
    setLoadingConfirm(true);

    try {
      await window.confirmationResult.confirm(code);
      localStorage.session = 'true';
      localStorage.events = JSON.stringify([
        '20 - acesso',
        '30 - sms',
        '40 - código de acesso',
        '50 - primeiro acesso',
      ]);
    } catch (error) {
      if (error.code) {
        enqueueSnackbar(firebaseErrors[error.code], {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        });
        Sentry.captureException(new Error('failed to verify code'));
      }
      resetRecaptcha();
    } finally {
      setLoading(false);
      setLoadingConfirm(false);
    }
  };

  // Reenvio do código de confirmação
  const retryVerification = async () => {
    closeMissingModal();

    setLoading(true);

    const appVerifier = window.recaptchaVerifier;

    try {
      const result = await fb.auth().signInWithPhoneNumber(user.phone, appVerifier);
      window.confirmationResult = result;

      // Exibe modal para inserir o código de verificação
      showModal();
      localStorage.setItem('mkt_cookies', mktInputRef.current.value);
      localStorage.setItem('event', 'register/customer');
    } catch (error) {
      setLoading(false);
      if (error.code) {
        enqueueSnackbar(firebaseErrors[error.code], {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        });
      }
      resetRecaptcha();
    }
  };

  // Login com a conta do Facebook
  const handleSignWithFacebook = async () => {
    try {
      await fb.auth().signInWithPopup(facebookProvider);
      /** @type {firebase.auth.OAuthCredential} */

      localStorage.session = 'true';
      localStorage.events = JSON.stringify([
        '21 - acesso facebook',
        '50 - primeiro acesso',
      ]);
      localStorage.setItem('mkt_cookies', mktInputRef.current.value);
      localStorage.setItem('event', 'register/customer');
    } catch (error) {
      Sentry.captureException(new Error('failed to login with Facebook'));
      if (error.code) {
        enqueueSnackbar(firebaseErrors[error.code], {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        });
      }
    }
  };

  if (loadingPage) return <Loading bg="white" />;

  return (
    <>
      {/* MENU */}
      <Menu />
      {/* CONTEÚDO */}
      <Wrapper>
        {/* MODAL DE CÓDIGO DE CONFIRMAÇÃO */}
        <CodeModal
          phone={user.phone}
          open={openModal}
          onClose={closeModal}
          loading={loadingConfirm}
          showModal={showMissingModal}
          showEmailModal={showEmailModal}
          complete={completeVerification}
        />
        {/* MODAL DE CÓDIGO NÃO RECEBIDO */}
        <MissingCodeModal
          phone={user.phone}
          open={openMissingModal}
          retry={retryVerification}
          onClose={closeMissingModal}
        />
        {/* MODAL DE LOGIN POR LINK DE EMAIL */}
        <EmailModal
          email={user.email}
          handleChange={handleChange}
          handleSubmit={handleSignWithEmail}
          open={openEmailModal}
          complete={complete}
          onClose={closeEmailModal}
          setSignMethod={setSignMethod}
        />
        <Container>
          <Title>Bem vindo(a) de volta!</Title>
          <Text>Insira seus dados abaixo para entrar</Text>
          {/* FORMULÁRIO DE CADASTRO */}
          <form
            style={{ margin: '10px 0' }}
            onSubmit={signMethod === 'email' ? handleSignWithEmail : handleSignInWithPhone}
          >
            {/* Número de celular (com máscara) */}
            {
              signMethod === 'phone' && (
                <SimpleInputMask
                  icon
                  required
                  autoFocus
                  name="phone"
                  type="tel"
                  mask="+55 (99) 9 9999-9999"
                  placeholder="Número do celular"
                  value={user.phone}
                  onChange={handleChange}
                  title="Insira o seu número de celular"
                />
              )
            }
            {/* E-mail */}
            {
              signMethod === 'email' && (
                <Input
                  icon
                  required
                  autoFocus
                  name="email"
                  type="email"
                  value={user.email}
                  onChange={handleChange}
                  placeholder="E-mail"
                  title="Insira o seu E-mail"
                />
              )
            }
            <input
              type="hidden"
              name="mkt_cookies"
              className="mkt_cookies"
              value=""
              ref={mktInputRef}
            />
            <Button
              type="submit"
              loading={loading}
              style={{ marginTop: 18 }}
            >
              Entrar
            </Button>
            <Link to={PATH.SIGNUP}>
              <Button
                variant="outlined"
                className="unset"
              >
                Ainda não possuí cadastro?
              </Button>
            </Link>
            {
              !localStorage.getItem('webview') && (
                <>
                  <Divider>ou</Divider>
                  <Button
                    variant="outlined"
                    onClick={handleSignWithGoogle}
                    startIcon={<GoogleIcon />}
                    style={{ margin: '10px 0' }}
                  >
                    Entre com o Google
                  </Button>
                  <Button
                    variant="outlined"
                    startIcon={<FaFacebookSquare color="#4267B2" />}
                    onClick={handleSignWithFacebook}
                  >
                    Entre com o Facebook
                  </Button>
                </>
              )
            }
            <Button
              variant="outlined"
              className="unset"
              onClick={() => {
                setSignMethod(signMethod === 'email' ? 'phone' : 'email');
              }}
              style={{ fontSize: 14 }}
            >
              Logar com {signMethod === 'email' ? 'número de celular' : 'E-mail'}?
            </Button>
            {/* Reaptcha container */}
            <div id="recaptcha-container" />
          </form>
        </Container>
      </Wrapper>
    </>
  );
};

export default Login;
